<fieldset class="display-request">
    <legend class="form-row p-2 pl-3 mb-4 bg-dark-blue text-white"><p><strong>requests</strong></p></legend>

    <div *ngFor="let req of requests">
        <display-form [displayObject]="req" [displayFields]="displayProperties"></display-form>
        <mat-divider class="mt-4 mb-4"></mat-divider>
    </div>
</fieldset>